export enum MsgType {
  Warn = 'warning',
  Info = 'info',
  Error = 'error',
  Success = 'check_circle'
}
export interface MsgProps {
  type: MsgType;
  message: string;
}
